import { identity, contains, constant, chain, negate, has } from 'underscore';
import { mapBulkUpsertErrors } from '../common/map-bulk-upsert-errors';

const getBulkUploadEntityType = entitySchema =>
  (entitySchema.properties['bulk-upload-type'] || {}).value ||
  entitySchema.name;

export const getBulkUploadErrorType = entitySchema =>
  `${getBulkUploadEntityType(entitySchema)} Error`;

export const modelToViewModelForBulkErrors = (errors, bulkUpsertEntityErrorMap, scenario, i18n, activityLogger) =>
  mapBulkUpsertErrors(errors, bulkUpsertEntityErrorMap, /* errorProcessor */ identity, scenario, i18n, activityLogger);

export const removeErrors = (bulkErrors, filter) =>
  bulkErrors.filter(negate(filter));

export const isAudienceAssociationDoesntExistError = ({ Error }) => Error === 'AssetGroupAudienceGroupAssociationDoesNotExist';

const ReferencedEntityInvalidIdErrors = ['CampaignServiceInvalidCampaignId', 'AssetGroupIdInvalid'];
export const isReferencedEntityInvalidIdError = ({ Error }) => contains(ReferencedEntityInvalidIdErrors, Error);
export const removeReferencedEntityInvalidIdErrors = bulkErrors =>
  bulkErrors.filter(negate(isReferencedEntityInvalidIdError));

export const hasBulkErrorsForEntityType = (bulkErrors, entityType, filter = constant(true)) =>
  chain(bulkErrors)
    .filter(filter)
    .some(({ Type }) => Type === entityType)
    .value();

export const unexpectedBulkErrorToString = bulkOrSystemError =>
  // If it is an Error instance
  bulkOrSystemError.stack ||
  bulkOrSystemError.message ||
  // If it is a jQuery.ajax completion error object
  (has(bulkOrSystemError, 'status') && has(bulkOrSystemError, 'statusText') && `[jQuery.ajax] { status: ${bulkOrSystemError.status}, statusText: ${bulkOrSystemError.statusText} }`) ||
  // Everything else
  bulkOrSystemError;
